/* template */
<template><div class="transfor-order-card"><div v-for="(orderList, index) in (segmentList)" :key="orderList.index" class="transfer-segment-card" v-if="(orderList)"><div class="content"><div class="content-header"><mpx-image src="https://ut-static.udache.com/webx/sfc/E-gDDXz0ky_iMRsP5PAOK.png" class="content-header-icon"/><span class="content-header-text">第{{ index + 1 }}程</span></div><order-info-list isTransfer @click="showSSI" :orderList="(orderList)" :isChange="(getIsChange(orderList))"/></div><div class="tip" v-if="(index !== segmentList.length -1)"><mpx-image src="https://ut-static.udache.com/webx/sfc/f7hhMa7YrgQP9UnbmT__E.png" class="tip-icon"/><transfer-info-tip :style='["flex: 1"] | transRpxStyle' noIcon :orderId="(baseInfo.order_id)" :startStation="(segmentList[index][0]?.to_station_name ?? '')" :toStation="(segmentList[index+1][0]?.from_station_name ?? '')" :stopTime="(stopTime)"/></div><div class="line" v-if="(index !== segmentList.length -1)"></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m654d340e"}'>
.transfor-order-card
  display flex
  flex-direction column
  background #fff
  margin 0 -12px 10px
  padding 7px 10px 0 30px
  .transfer-segment-card
    display flex
    flex-direction column
    position relative
    .content
      position relative
      z-index 2
      display flex
      flex-direction column
      &-header
        display flex
        align-items center
        margin-left -25px
        margin-bottom 10px
        &-icon
          height 20px
          width 20px
          margin-right 5px
        &-text
          font-family PingFangSC-Medium
          font-size 18px
          font-weight 500
          line-height 18px
          letter-spacing 0.08em
          color #222
    .tip
      display flex
      align-items center
      margin-left -23.5px
      position relative
      z-index 2
      padding-bottom 11px
      &-icon
        height 17.5px
        width 17.5px
        margin-right 6px
    .line
      position absolute
      top 0
      left -15.5px
      height 100%
      width 0
      border-right 1px dashed #CCCCCC
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m654d340e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./transfer-order-card.mpx.js?isComponent&outputPath=components%2Ftransfer-order-card654d340e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./transfer-order-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftransfer-order-card654d340e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m654d340e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/transfer-order-card654d340e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'transfer-info-tip':getComponent(require("../../../components/transfer-info-tip.mpx?isComponent&outputPath=components%2Ftransfer-info-tip794aa58f%2Findex")),'order-info-list':getComponent(require("../../../components/order-info-list/index.mpx?isComponent&outputPath=components%2Findex55870adc%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
